import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

class Timer extends Component {
    zeroPadding = (number) => {
        if(number.toString().length === 1) {
            return 0 + number.toString();
        }

        return number;
    }
    
    render() {
        const { maxTime } = this.props;
        const { timeTaken } = this.props;

        if(timeTaken > maxTime) {
            return (
                <React.Fragment>
                    00:00
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                {this.zeroPadding(Math.abs(Math.floor((maxTime - timeTaken) / 60)))}:{this.zeroPadding(Math.abs((maxTime - timeTaken) % 60))}
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps({ quizApp, timer }) {
    return {
        timeTaken: timer.timeTaken,
        maxTime:   timer.maxTime,
        onFinish:  timer.onFinish,
    }
}

export default withStyles(null, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Timer)));




// WEBPACK FOOTER //
// src/main/components/timer/Timer.js